import React from "react";
import { buildCruiseName } from "src/utils/cruise";
import * as styles from "./CruiseSegmentCard.module.scss";
import DateOnlyFormat from "components/DateOnlyFormat";
import classNames from "classnames";
import { CruiseSegment } from "src/templates/SpecialVoyage/SpecialVoyage";

export interface CruiseSegmentCardProps {
  segment: CruiseSegment;
  active: boolean;
  onClick: (cruise: CruiseSegment) => void;
}

const CruiseSegmentCard: React.FC<CruiseSegmentCardProps> = ({
  segment,
  onClick,
  active = false
}) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames({
        [styles.container]: true,
        [styles.active]: active
      })}
      onClick={() => onClick(segment)}
      onKeyDown={() => onClick(segment)}
    >
      <div className={styles.dates}>
        <div className={styles.departureDate}>
          <DateOnlyFormat
            value={segment.data?.departureDate}
            format={{
              year: "numeric",
              month: "short",
              day: "numeric"
            }}
          />
        </div>
        <div className={styles.arrivalDate}>
          <DateOnlyFormat
            value={segment.data?.arrivalDate}
            format={{
              year: "numeric",
              month: "short",
              day: "numeric"
            }}
          />
        </div>
      </div>
      <div className={styles.cruiseName}>{buildCruiseName(segment)}</div>
    </div>
  );
};

export default CruiseSegmentCard;
